import gql from "graphql-tag";

const SEED_OPENING_INVENTORY_MUTATION = gql`
  mutation SeedOpeningInventory {
    seedOpeningInventory {
      total
      ok
      errors
    }
  }
`;

export default SEED_OPENING_INVENTORY_MUTATION;
